const Arrow = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 5L7 10L13 15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default Arrow
